/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menusectioncountone3Inputs */

const en_menusectioncountone3 = /** @type {(inputs: Menusectioncountone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 section`)
};

const de_menusectioncountone3 = /** @type {(inputs: Menusectioncountone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Bereich`)
};

/**
* | output |
* | --- |
* | "1 section" |
*
* @param {Menusectioncountone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menusectioncountone3 = /** @type {((inputs?: Menusectioncountone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menusectioncountone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menusectioncountone3(inputs)
	return de_menusectioncountone3(inputs)
});
export { menusectioncountone3 as "menuSectionCountOne" }